module.exports = __webpack_public_path__ + "static/index/img/baikal-208.13116cc7.jpg";